export default "__VITE_ASSET__4f925654__"